import { useIntl } from 'react-intl';
import DocumentFileName from '@rossum/components/filename/DocumentFileName';
import StatusChip from '@rossum/components/status/StatusChip';
import { IconCornerDownRight, IconFileTypeZip } from '@rossum/ui/icons/tabler';
import {
  ListItem,
  ListItemIcon,
  ListItemText,
  SvgIcon,
  Tooltip,
} from '@rossum/ui/material';
import { borderRadius } from '@rossum/ui/theme';
import { Document } from '../../../../types/document';

type Props = {
  attachment: Document;
  isChild: boolean;
};

const DocumentAttachment = ({ attachment, isChild }: Props) => {
  const intl = useIntl();

  return (
    <ListItem
      component="div"
      sx={{
        pl: 2,
        py: 0.5,
        borderRadius: borderRadius('s'),
      }}
    >
      {isChild && (
        <SvgIcon
          fontSize="medium"
          sx={{ color: theme => theme.palette.text.secondary }}
        >
          <IconCornerDownRight />
        </SvgIcon>
      )}
      {attachment.attachmentStatus === 'extracted_archive' ? (
        <ListItemIcon sx={{ minWidth: 24 }} data-cy="document-zip">
          <SvgIcon
            fontSize="small"
            sx={{
              color: theme => theme.palette.text.secondary,
            }}
          >
            <IconFileTypeZip />
          </SvgIcon>
        </ListItemIcon>
      ) : (
        <Tooltip
          title={intl.formatMessage(
            { id: 'components.documentAttachment.reason' },
            { reason: attachment.attachmentStatus }
          )}
        >
          <ListItemIcon sx={{ minWidth: 25, maxWidth: 200, mr: 1 }}>
            <StatusChip status="notExtracted" />
          </ListItemIcon>
        </Tooltip>
      )}
      <ListItemText primaryTypographyProps={{ color: 'text.secondary' }}>
        <DocumentFileName originalFileName={attachment.originalFileName} />
      </ListItemText>
    </ListItem>
  );
};

export { DocumentAttachment };
